// bao migrate skip
import TabPage from "./../factories/tab-page";
import "./../bindings/bao-upload";
import "./../bindings/bao-pager";
import "./../bindings/bao-tabs";
import "./../services/app-tab-controller";
import "./../bindings/bao-toolbar2";
import "./../bindings/element";
import "./../factories/translate-dialog";
import BaseViewModel from "./../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialog from "./../factories/bao-dialog";
import TranslateDialogViewModel from "./../factories/translate-dialog";
import StringUtils from "../../../src/projectx/services/bao-utils";

class ReportLayout extends BaseViewModel {
    Name1 = ko.observable();
    Name2 = ko.observable();
    Name3 = ko.observable();
    Name4 = ko.observable();
    Name5 = ko.observable();
    Description1 = ko.observable();
    Description2 = ko.observable();
    Description3 = ko.observable();
    Description4 = ko.observable();
    Description5 = ko.observable();
    Key = ko.observable();
    XmlLayout = ko.observable();
    TemplateUploadEnabled = ko.observable(true);
    ReportLayoutId = ko.observable();
    Filename = ko.observable();
    Layout = ko.observable();
    ReportName = ko.observable();
    //UploadAttachment = () => { };
    SessionTabId: KnockoutObservable<string>;
    public constructor(tabPage: TabPage) {
        super(tabPage);
        this.Filename.subscribe(() => {
            Bao.post("ReportLayout/SetReportNames", JSON.stringify({ reportLayoutId: this.ReportLayoutId() }), (result) => {
                this.ReportName(result);
            });
        });
    }
    Name = ko.pureComputed({
        read: () => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    return this.Name1();
                case 2:
                    return this.Name2();
                case 3:
                    return this.Name3();
                case 4:
                    return this.Name4();
                case 5:
                    return this.Name5();
            }
        },
        write: (value) => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    this.Name1(value);
                    break;
                case 2:
                    this.Name2(value);
                    break;
                case 3:
                    this.Name3(value);
                    break;
                case 4:
                    this.Name4(value);
                    break;
                case 5:
                    this.Name5(value);
                    break;
            }
        }
    });
    Description = ko.pureComputed({
        read: () => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    return this.Description1();
                case 2:
                    return this.Description2();
                case 3:
                    return this.Description3();
                case 4:
                    return this.Description4();
                case 5:
                    return this.Description5();
            }
        },
        write: (value) => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    this.Description1(value);
                    break;
                case 2:
                    this.Description2(value);
                    break;
                case 3:
                    this.Description3(value);
                    break;
                case 4:
                    this.Description4(value);
                    break;
                case 5:
                    this.Description5(value);
                    break;
            }
        }
    });
    Download() {
        window.open(Bao.Content("ReportLayout/Download/" + this.ReportLayoutId()), '_blank');
    }
    ;
    TranslateName() {
        let translateDialog = new TranslateDialogViewModel(this.Name1, this.Name2, this.Name3, this.Name4, this.Name5);
        translateDialog.Open().then(() => {
        });
    }
    ;
    TranslateDescription() {
        let translateDialog = new TranslateDialogViewModel(this.Description1, this.Description2, this.Description3, this.Description4, this.Description5);
        translateDialog.Open().then(() => {
        });
    }
    ;
    PerformRefresh() {
        if (this.ReportLayoutId() != null) {
            Bao.post("ReportLayout/SetReportNames", JSON.stringify({ reportLayoutId: this.ReportLayoutId() }), (result) => {
                this.ReportName(result);
            });
        }
        return super.PerformRefresh();
    }
    //LoadUrl = ko.computed(function () {
    //    return "UniversalReportLayout/UploadTemplate/?universalReportLayoutId=" + this.UniversalReportLayoutId();
    //}, this);
    public CompleteCheck(): JQueryPromise<boolean> | boolean {
        var completed: boolean;
        completed = true;

        if (this.Key() === "" || this.Key() === null) {
            completed = false;
        }
        if (Bao.Utils.String.IsNullOrWhitespace(this.Name())) {
            completed = false;
        }
        if (!completed) {
            var baoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return completed;
    }
    UploadLayout() {
        //dummy
    }
    Save() {
        return super.Save().then(() => {
            Bao.post("ReportLayout/SaveReportLayout", JSON.stringify({ reportLayoutId: this.ReportLayoutId(), name: this.Name(), description: this.Description(), key: this.Key(), filename: this.Layout }), (result) => {
            });
            return this.UploadLayout();
        }).then(() => {
            this.PerformRefresh();
        });
    }
    loaded() {
        super.loaded();
    }
    public InitUrl(): string {
        return "ReportLayout/Init";
    }
    public init(): JQueryPromise<void> {
        if (this.ReportLayoutId() != null) {
            Bao.post("ReportLayout/SetReportNames", JSON.stringify({ reportLayoutId: this.ReportLayoutId() }), (result) => {
                this.ReportName(result);
            });
        }
        return super.init();
    }
}
export default ReportLayout;